// extracted by mini-css-extract-plugin
var _1 = "GitlabInstructionModal-module__copyPaste--ASPw6";
export { _1 as "copyPaste" }
